import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

declare function delay(time): Promise<any>;

@Component({
    selector: 'app-confirmation-close-dialog',
    templateUrl: './confirmation-close-dialog.component.html',
    styleUrls: ['./confirmation-close-dialog.component.scss'],
    standalone: false
})
export class ConfirmationCloseDialogComponent implements OnInit {
  inactive: any
  mins: any
  isError: boolean = true

  constructor(public dialogRef: MatDialogRef<ConfirmationCloseDialogComponent>,
              @Inject(MAT_DIALOG_DATA) data) {

    this.inactive = data.inactive
    this.mins = data.mins

    if (data.mins > 0) {
      this.isError = false

      delay(60000 * data.mins).then(() => {
        this.isError = true
      })
    }
  }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close(!this.isError); //return true if warning, return false if error
  }
}
